export default function ProcessorViewShell({ title, intro, metrics = [], actions, children }) {
  return (
    <section className="processor-view processor-view--pending-actions">
      <div className="workspace-panel processor-view__hero processor-view__hero--compact">
        <div className="processor-view__hero-copy">
          <div className="processor-view__heading-row">
            <div className="processor-view__heading-copy">
              
              <h2>{title}</h2>
              <p className="processor-view__intro">{intro}</p>
            </div>

            {metrics.length ? (
              <div className="processor-metrics processor-metrics--inline">
                {metrics.map((metric) => (
                  <article key={metric.label} className="processor-metric-card">
                    <span className="processor-metric-card__label">{metric.label}</span>
                    <strong>{metric.value}</strong>
                  </article>
                ))}
              </div>
            ) : null}
          </div>
        </div>

        {actions ? <div className="processor-view__hero-actions">{actions}</div> : null}
      </div>

      {children}
    </section>
  );
}
